export const isANumber = value => !Number.isNaN(Number(value));
export const isNaN = value => Number.isNaN(Number(value));
export const isAStrictNumber = str =>
  !Number.isNaN(Number(`${str}`)) && !Number.isNaN(Number.parseFloat(`${str}`));
export const isAStrictInteger = str =>
  !Number.isNaN(Number(`${str}`)) &&
  !Number.isNaN(Number.parseFloat(`${str}`)) &&
  Number.isInteger(Number(`${str}`));
